import { useMemo } from 'react';

import { useTranslation } from 'react-i18next';

import type { ChipsItem } from '@/components/chips';

import { LineDrawStyle } from './types.ts';

/** Line/Points chips shared by the chart configuration and the selector on the chart. */
export const useDrawStyleChips = (drawStyle: LineDrawStyle | undefined) => {
  const { t } = useTranslation(['chartConfig']);

  return useMemo(() => {
    const line: ChipsItem<LineDrawStyle> = {
      id: LineDrawStyle.LINE,
      label: t('chartConfig:linear.drawStyle.line'),
      value: LineDrawStyle.LINE,
    };
    const points: ChipsItem<LineDrawStyle> = {
      id: LineDrawStyle.POINTS,
      label: t('chartConfig:linear.drawStyle.points'),
      value: LineDrawStyle.POINTS,
    };
    return { items: [line, points], selected: drawStyle === LineDrawStyle.POINTS ? points : line };
  }, [drawStyle, t]);
};
